export default {
  elevation1: '0px 2px 8px rgba(0, 0, 0, 0.15)',
  elevation2: '0px 4px 12px rgba(0, 0, 0, 0.15)',
};
